<template>
<div>
    <div class="modal fade" role="dialog" id="ModalDeleteGrupoWorker">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">¿Desea eliminar este grupo de workers?</h4>
                </div>
                <div class="modal-footer">
                    <button class="btn" data-dismiss="modal">Cancelar</button>
                    <button class="btn-danger btn" @click="accion">Eliminar</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    methods: {
        show() {
            $('#ModalDeleteGrupoWorker').modal('show');
        },
        hide() {
            $('#ModalDeleteGrupoWorker').modal('hide');
        },
        accion() {
            this.$emit('eliminar');
            this.hide();
        },
    },
};
</script>
